import { render } from "./transferModal.vue?vue&type=template&id=234e4079&scoped=true"
import script from "./transferModal.vue?vue&type=script&lang=js"
export * from "./transferModal.vue?vue&type=script&lang=js"

import "./transferModal.vue?vue&type=style&index=0&id=234e4079&scoped=true&lang=css"

import exportComponent from "/builds/aksoftware/software/haushaltsbuchfrontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234e4079"]])

export default __exports__